
import "./App.css";
import Nav from "./Componants/Nav";
import RoutesComponent from "../src/Componants/Routes";
import Footer from "./Componants/Footer";

function App() {

  return (
    <div>
      <Nav />
      <RoutesComponent />
      <Footer />
    </div>
  );
}

export default App;

